import PropTypes from 'prop-types'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'

const DtcMappingErrorsRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-2/12 pl-10 items-center table_text">
          <Tooltip message={props?.acronym}>
            <div>{formatEmptyValue(props.acronym)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.dtc}>
            <div>{formatEmptyValue(props.dtc)}</div>
            <div>{formatEmptyValue(props.dtc_description)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.vin}>
            <div>{formatEmptyValue(props.vin)}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.data_version}>
            <div>{formatEmptyValue(props.data_version)}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-2 flex-wrap items-center table_text">
          <div className="flex gap-2">
            <div className="bg-tracer-dark-blue text-white px-1">
              MODULE INSTALLED : {formatEmptyValue(props.is_supported)}
            </div>
            <div className="bg-tracer-dark-blue text-white px-1">
              MISCONFIGURED : {props.is_misconfigured == null ? 'No' : 'Yes'}
            </div>
          </div>
          <div className="flex mt-2 gap-2">
            <div className="bg-tracer-dark-blue text-white px-1">
              NO RESULTS DISPLAYED : {props.is_missing_component_in_graph}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DtcMappingErrorsRow.propTypes = {
  acronym: PropTypes.string.isRequired,
  dtc: PropTypes.string.isRequired,
  vin: PropTypes.string.isRequired,
  dtc_description: PropTypes.string.isRequired,
  connectors_mapped_successfully: PropTypes.string.isRequired,
  data_version: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default DtcMappingErrorsRow
